import React from "react";
import { Badge } from "@/components/ui/badge";
import { Shield, Users, UserCheck } from "lucide-react";

interface PollAccessIndicatorProps {
  isAnonymousAllowed: boolean;
  isPublicVotingAllowed?: boolean;
}

const PollAccessIndicator: React.FC<PollAccessIndicatorProps> = ({
  isAnonymousAllowed,
  isPublicVotingAllowed = false,
}) => {
  // Determine the access level and appropriate messaging
  if (isAnonymousAllowed && isPublicVotingAllowed) {
    return (
      <div className="flex items-center gap-2 mb-2">
        <Badge
          variant="outline"
          className="flex items-center gap-1 bg-green-50 text-green-700 border-green-200"
        >
          <Users size={14} />
          <span>Open to All</span>
        </Badge>
      </div>
    );
  }

  if (isPublicVotingAllowed) {
    return (
      <div className="flex items-center gap-2 mb-2">
        <Badge
          variant="outline"
          className="flex items-center gap-1 bg-blue-50 text-blue-700 border-blue-200"
        >
          <UserCheck size={14} />
          <span>Verified + Unverified Users</span>
        </Badge>
      </div>
    );
  }

  if (isAnonymousAllowed) {
    return (
      <div className="flex items-center gap-2 mb-2">
        <Badge
          variant="outline"
          className="flex items-center gap-1 bg-green-50 text-green-700 border-green-200"
        >
          <Users size={14} />
          <span>Verified + Anonymous Users</span>
        </Badge>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 mb-2">
      <Badge
        variant="outline"
        className="flex items-center gap-1 bg-amber-50 text-amber-700 border-amber-200"
      >
        <Shield size={14} />
        <span>Verified Users Only</span>
      </Badge>
    </div>
  );
};

export default PollAccessIndicator;
